import { useState } from "react";
import PayementAvanceSalaireEspeceFN from "./PayementMethods/PayementAvanceSalaireEspeceFN";
import PayementAvanceSalaireChequeFN from "./PayementMethods/PayementAvanceSalaireChequeFN";
import PayementAvanceSalaireVirementFN from "./PayementMethods/PayementAvanceSalaireVirementFN";
import PayementAvanceSalaireEnLigneFN from "./PayementMethods/PayementAvanceSalaireEnLigneFN";

const MethodePayementSalaireAvance = () => {
  const [methodePayement, setMethodePayement] = useState("");

  const createUIPayement = () => {
    if (methodePayement === "CHEQUE") {
      return <PayementAvanceSalaireChequeFN />;
    } else if (methodePayement === "VIREMENT") {
      return <PayementAvanceSalaireVirementFN />;
    } else if (methodePayement === "ESPECE") {
      return <PayementAvanceSalaireEspeceFN />;
    } else if (methodePayement === "ENLIGNE") {
        return <PayementAvanceSalaireEnLigneFN />;
    }
  };
  const handleChangePayement = (e) => {
    let payement = e.target.value;
    setMethodePayement(payement);
  };
  const listOptionsPayement = () => {
    return (
      <select class="form-control" onChange={handleChangePayement}>
        <option key={0} value={0}>
          Sélectionner un mode de payement
        </option>
        <option key={1} value={"ESPECE"}>
          Espèce
        </option>
        <option key={2} value={"ENLIGNE"}>
          En ligne
        </option>
        <option key={3} value={"CHEQUE"}>
          Chèques / Traites
        </option>
        <option key={4} value={"VIREMENT"}>
          Virement
        </option>
      </select>
    );
  };
  return (
    <div className="card-body">
      <h5 className="card-title">Choisir le mode de payement </h5>
      <div class="row">
        <div class="col-2"></div>
        <div class="col-10">{listOptionsPayement()}</div>
      </div>

      {createUIPayement()}
      <br />
    </div>
  );
};
export default MethodePayementSalaireAvance;
